import Error from '@mui/icons-material/ErrorOutline';
import { Box } from '@mui/material';

export type ErrorMessageProps = {
  readonly message?: string;
};

export function ErrorMessage(props: ErrorMessageProps): JSX.Element {
  return (
    <Box sx={{ p: 0.5, color: 'error.main' }}>
      <Error data-testid="error-message" sx={{ verticalAlign: 'middle', mr: 0.5 }} />
      <Box component="span" sx={{ verticalAlign: 'middle' }}>
        {props.message}
      </Box>
    </Box>
  );
}

export default ErrorMessage;
